/* unplugin-vue-components disabled */import script from "./message-room-default.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-room-default.vue?vue&type=script&setup=true&lang=ts"

import "./message-room-default.vue?vue&type=style&index=0&id=75d2d456&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75d2d456"]])

export default __exports__